import { render, staticRenderFns } from "./Static.vue?vue&type=template&id=68b60cd7&scoped=true&"
import script from "./Static.vue?vue&type=script&lang=js&"
export * from "./Static.vue?vue&type=script&lang=js&"
import style0 from "./Static.vue?vue&type=style&index=0&id=68b60cd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b60cd7",
  null
  
)

export default component.exports